module.exports = __webpack_public_path__ + "static/media/Full-Funnel B2B Demand Generation@4x.1e4bca49.png";